<template>
  <v-container>
    <v-card flat style="border-radius: 0">
      <v-card-text class="px-3">
        <h5 style="display: inline-block">Panel de Agentes</h5>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap>
          <v-layout row wrap v-if="agent_data != null">
            <div
              v-if="loader.agentData"
              style="position: absolute; background: rgba( 255,255,255,0.7 ); width: 100%; height: 100%;"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                :size="50"
                style="position: absolute; top: 50%; left: 50%; transform: translate( -50%, -50% );"
              ></v-progress-circular>
            </div>
            <v-flex md12 sm12 class="pr-2">
              <h5>Datos del Agente</h5>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Nombre" v-model="agent_datas.name" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Dirección" v-model="agent_datas.direction" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Distrito" v-model="agent_datas.district" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Provincia" v-model="agent_datas.province" disabled></v-text-field>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="Referencia" v-model="agent_datas.reference" disabled></v-text-field>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="Horario de Atención" v-model="agent_datas.schedule" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="ID" v-model="agent_datas.agents" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="RUC" v-model="agent_datas.ruc" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Representante" v-model="agent_datas.representative" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Telefonos" v-model="agent_datas.phone" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Fecha de Creación" v-model="agent_datas.start_date" disabled></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Email" v-model="agent_datas.email" disabled></v-text-field>
            </v-flex>
            <v-flex md4 sm12 class="pr-2">
                 <a :href="'https://maps.google.com/maps?q='+agent_datas.geoLat+','+agent_datas.geoLong+'&z=17&hl=es'" target="_blank" ><v-btn color="info">UBICACIÓN</v-btn></a>
            </v-flex>
             <v-flex md4 sm12 class="pr-2">
                 <a :href="'href:tel:'+agent_data.phone" target="_blank" ><v-btn color="info">LLAMAR</v-btn></a>
            </v-flex>
             <v-flex md4 sm12 class="pr-2">
                <a :href="'href:mailto:'+agent_data.email"  target="_blank" > <v-btn color="info">ESCRIBIR</v-btn></a>
            </v-flex>
            </v-layout>
         
        </v-layout>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
      <v-icon>{{ snackbar.icon }}</v-icon>
      &nbsp;
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "@/api/axios/config";
import base_url from "@/api/axios/base_url";
import vueDropzone from "vue2-dropzone";

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      agent_data: null,
      agent_datas: [],
      loader: {
        agentData: false,
        saveBtn: false
      },
      snackbar: {
        icon: "",
        text: "",
        color: "",
        show: false
      },
      pickers: {
        date: false,
        exp_date: false
      }
    };
  },
  computed: {
    formatDate() {
      return this.form.date ? moment(this.form.date).format("DD/MM/YYYY") : "";
    },
    formatExpDate() {
      return this.form.exp_date
        ? moment(this.form.exp_date).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    this.getData();
  },
  methods: {
    close() {
      this.$router.push("/data/historial");
    },
    getData() {
      this.agent_data = true;
      this.agentData = true;
      axios
        .get("agents/"+ this.$route.params.id)
        .then(response => {
          if (response.data.status) {
            this.agent_datas = response.data.items;
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
        })
        .finally(() => {
          this.loader.disableInput = false;
          this.loader.saveBtn = false;
        });
    }
  }
};
</script>

<style scoped>
.dragzone {
  border: dashed 2px #bbb;
  border-radius: 10px;
}
.locate-middle {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  color: #bbb;
}
#drop1 {
  cursor: pointer;
  height: auto;
  padding: 40px;
  border: dashed 2px #bbb;
  color: #bbb;
  font-size: 17px;
  background: transparent;
  border-radius: 10px;
}
#drop1 .dz-preview {
  width: 40%;
}

.dz-image,
.dz-details {
  border-radius: 5px !important;
}
</style>